module.exports = __webpack_public_path__ + "static/media/logo_white.31dcf486.svg";